import { createRoot } from 'react-dom/client';
import type { Root } from 'react-dom/client';
import type { ComponentType } from 'react';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import Modal from 'components/partials/modal/modal';
import store from 'state/store';
import queryClient from 'utils/query-client';

const MODAL_CONTAINER = document.getElementById('modal-container');
let modalRoot: Root | null = null;

export type ModalProps = Record<string, unknown>;

const ModalAsAny = Modal as unknown as ComponentType<ModalProps>;

export const renderModal = (props: ModalProps): void => {
  if (!modalRoot) {
    if (!MODAL_CONTAINER) return;
    modalRoot = createRoot(MODAL_CONTAINER);
  }
  modalRoot.render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ModalAsAny {...props} />
      </QueryClientProvider>
    </Provider>
  );
};

export const unmountModal = (): void => {
  if (modalRoot) {
    modalRoot.unmount();
    modalRoot = null;
  }
};
